import React, { useEffect, useState } from 'react';
import { SunIcon, MoonIcon } from 'lucide-react';
const navLinks = [{
  label: 'Projekt',
  href: '#overview'
}, {
  label: 'Galerie',
  href: '#gallery'
}, {
  label: 'Standardy',
  href: '#standards'
}, {
  label: 'Lokalita',
  href: '#location'
}, {
  label: 'Kontakt',
  href: '#contact'
}];
interface NavbarProps {
  theme: 'dark' | 'light';
  onToggleTheme: () => void;
}
export function Navbar({
  theme,
  onToggleTheme
}: NavbarProps) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth'
      });
    }
    setMobileOpen(false);
  };
  const scrolledBg = theme === 'dark' ? 'bg-villa-dark/95 backdrop-blur-md border-b border-[var(--color-border-subtle)]' : 'bg-villa-bg/95 backdrop-blur-md border-b border-[var(--color-border)]';
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? scrolledBg : 'bg-transparent'}`} role="navigation" aria-label="Main navigation" data-id="element-112">
      <div className="max-w-7xl mx-auto px-6 md:px-10" data-id="element-113">
        <div className="flex items-center justify-between h-20" data-id="element-114">
          {/* Logo */}
          <a href="#hero" onClick={e => handleNavClick(e, '#hero')} className="font-playfair text-lg tracking-[0.25em] font-medium text-[#c9a96e]" data-id="element-115">
            MEZÍRKA
          </a>

          {/* Desktop Links + Toggle */}
          <div className="hidden md:flex items-center gap-10" data-id="element-116">
            {navLinks.map(link => <a key={link.href} href={link.href} onClick={e => handleNavClick(e, link.href)} className="text-[13px] tracking-[0.15em] uppercase font-inter font-light transition-colors duration-300 hover:text-villa-gold text-[#c9a96e]" data-id="element-117">
                {link.label}
              </a>)}

            {/* Theme Toggle */}
            <button onClick={onToggleTheme} className="text-villa-text/50 transition-colors duration-300 hover:text-villa-gold p-1" aria-label={theme === 'dark' ? 'Přepnout na světlý režim' : 'Přepnout na tmavý režim'} data-id="element-118">
              {theme === 'dark' ? <SunIcon className="w-[18px] h-[18px]" strokeWidth={1.4} data-id="element-119" /> : <MoonIcon className="w-[18px] h-[18px]" strokeWidth={1.4} data-id="element-120" />}
            </button>
          </div>

          {/* Mobile: Toggle + Hamburger */}
          <div className="flex md:hidden items-center gap-4" data-id="element-121">
            <button onClick={onToggleTheme} className="text-villa-text/50 transition-colors duration-300 hover:text-villa-gold p-1" aria-label={theme === 'dark' ? 'Přepnout na světlý režim' : 'Přepnout na tmavý režim'} data-id="element-122">
              {theme === 'dark' ? <SunIcon className="w-[18px] h-[18px]" strokeWidth={1.4} data-id="element-123" /> : <MoonIcon className="w-[18px] h-[18px]" strokeWidth={1.4} data-id="element-124" />}
            </button>

            <button className="text-villa-text p-2" onClick={() => setMobileOpen(!mobileOpen)} aria-label={mobileOpen ? 'Zavřít menu' : 'Otevřít menu'} aria-expanded={mobileOpen} data-id="element-125">
              <div className="w-6 flex flex-col gap-1.5" data-id="element-126">
                <span className={`block h-px bg-villa-text transition-all duration-300 ${mobileOpen ? 'rotate-45 translate-y-[3.5px]' : ''}`} data-id="element-127" />
                <span className={`block h-px bg-villa-text transition-all duration-300 ${mobileOpen ? '-rotate-45 -translate-y-[3.5px]' : ''}`} data-id="element-128" />
              </div>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`md:hidden overflow-hidden transition-all duration-500 ${mobileOpen ? 'max-h-80 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-129">
        <div className="bg-villa-dark/98 backdrop-blur-md border-t border-[var(--color-border-subtle)] px-6 py-8 flex flex-col gap-6" data-id="element-130">
          {navLinks.map(link => <a key={link.href} href={link.href} onClick={e => handleNavClick(e, link.href)} className="text-villa-text/70 text-sm tracking-[0.15em] uppercase font-inter font-light transition-colors duration-300 hover:text-villa-gold" data-id="element-131">
              {link.label}
            </a>)}
        </div>
      </div>
    </nav>;
}